var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-confirmation"},[_c('TextTitle',{attrs:{"size":"l"}},[_vm._v(_vm._s(_vm.title))]),_c('TextSimple',[_vm._v(_vm._s(_vm.text))]),_vm._t("default"),(_vm.button && _vm.to)?_c('ButtonLink',{attrs:{"to":_vm.to,"size":"m","color":"black","icon":"right"}},[_vm._v(_vm._s(_vm.button))]):_vm._e(),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }